export default __webpack_public_path__ + "static/media/sample_3.d2274445.png";